import React, { ElementType, ComponentProps } from "react";

type HeaderProps<T extends ElementType = "div"> = {
  as?: T;
  className?: string;
} & ComponentProps<T>;

const Header = <T extends ElementType = "div">({
  as,
  className,
  children,
  ...rest
}: HeaderProps<T>) => {
  const Element = as || "div";

  return (
    <Element className={className} {...rest}>
      {children}
    </Element>
  );
};

export default Header;
